import { render, staticRenderFns } from "./ApprovalModal.vue?vue&type=template&id=44b5a402&scoped=true"
import script from "./ApprovalModal.vue?vue&type=script&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalModal.vue?vue&type=style&index=0&id=44b5a402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5a402",
  null
  
)

export default component.exports